import React, { useState } from "react";
import { Button, Col, Row, Space, Table, Tooltip } from "antd";

import NoDataPage from "../../../../NoDataPages/NoDataPage";
import VitalsIcon from "../../../../../assets/images/nurseIcons/heart-rate.svg";
import GbrsIcon from "../../../../../assets/images/nurseIcons/grbs.svg";
import { convertUtcToIst } from "../../../../../helpers/utility";
import useQuery from "../../../../../hooks/useQuery";
import { grbsCols, vitalCols } from "./vitalGrbsCols";
import AddVitalGrbs from "./AddVitalGrbs";
import { InfoCircleOutlined } from "@ant-design/icons";
import EditIcon from "../../../../ui/EditIcon";
import useIsMobile from "../../../../../hooks/useIsMobile";
import useTabletMonitoringLayout from "../../../../../hooks/useTabletMonitoringLayout";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import dayjs from "dayjs";
dayjs.extend(utc);
dayjs.extend(timezone);

const getMobileColWidth = (title) => {
  const label = typeof title === "string" ? title : "";
  return Math.max(88, label.length * 7 + 28);
};

const VitalGrbsTable = ({ data, refresh, loading, type }) => {
  const [open, setOpen] = useState(false);
  const [editingKey, setEditingKey] = useState(null);
  const isActive = useQuery()?.status === "current";
  const isMobile = useIsMobile();
  const isTablet = useTabletMonitoringLayout();
  const isNarrowTable = isMobile || isTablet;

  const cols = type === "vitals" ? vitalCols : grbsCols;
  const colsWithWidth = cols.map((col) => ({
    ...col,
    width: isNarrowTable ? getMobileColWidth(col.title) : col.width,
  }));

  const columns = [
    {
      title: "Time",
      dataIndex: "action_time",
      width: isNarrowTable ? 72 : "10%",
      fixed: isNarrowTable ? "left" : undefined,
      render: (value) => (value ? convertUtcToIst(value, false, true) : "-"),
    },
    ...colsWithWidth,
    ...(isActive
      ? [
          {
            title: "Action",
            width: isMobile ? 88 : isTablet ? 150 : "12%",
            fixed: isNarrowTable ? "right" : undefined,
            render: (_, record) => {
             return (
               <Space size={8} className="nurse-monitoring-action-cell" wrap={false}>
                 <Button
                   className="nurse-monitoring-edit-btn"
                   onClick={() => {
                     setOpen(true);
                     setEditingKey(record);
                   }}
                 >
                   {isMobile ? (
                     <EditIcon />
                   ) : (
                     <Space>
                       <EditIcon />
                       Edit
                     </Space>
                   )}
                 </Button>
                 <Tooltip
                   placement="topLeft"
                   title={
                     <div>
                       <div>
                         <strong>Updated At:</strong>{" "}
                         {record?.updated_at
                           ? dayjs
                              .utc(record.updated_at)
                              .tz("Asia/Kolkata")
                              .format("DD-MM-YYYY hh:mm A")
                          : "-"}
                       </div>
                       <div style={{ marginTop: "4px" }}>
                         <strong>Processed By:</strong>{" "}
                         {record?.processed_by_name || "-"}
                       </div>
                     </div>
                   }
                 >
                   <InfoCircleOutlined
                     className="nurse-monitoring-info-icon"
                     style={{
                       fontSize: "16px",
                       color: "#1677ff",
                       cursor: "pointer",
                     }}
                   />
                 </Tooltip>
               </Space>
             );
           },

          },
        ]
      : []),
  ];

  const narrowScrollX = isNarrowTable
    ? Math.max(
        columns.reduce(
          (sum, col) =>
            sum + (typeof col.width === "number" ? col.width : 88),
          0
        ),
        type === "grbs" ? 560 : 720
      )
    : undefined;

  const tableScroll = isNarrowTable
    ? { x: narrowScrollX }
    : { y: "calc(100vh - 240px)", x: "400px" };

  return (
    <>
      {data?.length > 0 ? (
        <>
          <div className="nurse-monitoring-table-scroll">
            <Table
              className="nurse-monitoring-data-table ant-table-container ant-table-header"
              tableLayout={isNarrowTable ? "fixed" : undefined}
              scroll={tableScroll}
              bordered
              dataSource={data}
              columns={columns}
              rowClassName="editable-row"
              pagination={false}
              loading={loading}
            />
          </div>
          {open && (
            <AddVitalGrbs
              open={open}
              setOpen={setOpen}
              refresh={refresh}
              editData={editingKey}
              type={type}
            />
          )}
        </>
      ) : (
        <Row
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "70vh",
          }}
        >
          <Col span={24} style={{ textAlign: "center" }}>
            <NoDataPage
              title={
                type === "grbs"
                  ? "No GRBS Data Available"
                  : "No Vital Signs Data Available"
              }
              subtitle={
                "Please check back later or ensure all relevant data has been recorded."
              }
              image={type === "grbs" ? GbrsIcon : VitalsIcon}
            />
          </Col>
        </Row>
      )}
    </>
  );
};

export default VitalGrbsTable;
